<template>
  <div
    class="rating"
    :class="{'disabled': disabled}"
    :data-qa="dataQa"
    :style="`--size: ${size}px; --full-width: ${width}px`">
    <div
      v-for="i in count"
      :key="`${dataQa}-${i}`"
      class="rating-col my-auto"
      :data-qa="`${dataQa}-${i}`"
      @click="rating = i"
      @mouseleave="hover = 0"
      @mouseover="hover = i">
      <sIcon
        class="rating-icon"
        :color="validateState==='error' ? 'var(--color-error)' : null"
        :size="size"
        :type="rating >= i || i <= hover ? 'star' : 'star-outline'"/>
      <div
        v-if="showNumber"
        class="mt-2 pl-1">
        {{ i }}
      </div>
    </div>
  </div>
</template>
<script>
import Form from 'mixins/form-item.js'
/**
 * Компонент "Рейтинг"
 * @vue-prop {Number} value - Значение
 * @vue-prop {Number} count - Количество звезд
 * @vue-prop {String} dataQa - Идентификатор
 * @vue-prop {Boolean} showNumber - Отображать чисто
 * @vue-prop {Number} size - Размер
 * @vue-prop {Boolean} disabled
 *
 * @vue-computed {Number} rating - Значение
 * @vue-computed {Number} width - Ширина блока со звездой
 */
export default {
  name: 'ratingStar',
  mixins: [Form],
  data() {
    return {
      hover: 0
    }
  },
  computed: {
    rating: {
      get() {
        return this.value
      },
      set(value) {
        if (this.disabled) { return }
        let result = value === this.value ? null : value
        this.$emit('update:value', result)
        this.$_sendFormItemEvent(result)
      }
    },
    width() {
      return ((this.size + 38) * (this.count - 1)) + this.size
    }
  },
  props: {
    value: {
      type: Number,
      default: 1
    },
    count: {
      type: Number,
      default: 5
    },
    dataQa: {
      type: String,
      default: 'rating'
    },
    showNumber: {
      type: Boolean,
      default: false
    },
    size: {
      type: Number,
      default: 16
    },
    disabled: {
      type: Boolean,
    },
  },
}
</script>
<style scoped>
.rating {
  display: flex;
  flex-wrap: nowrap;
  width: calc(var(--full-width));
}
.rating.disabled {
  opacity: 0.5;
}
.rating-col {
  width: calc(var(--size) + 38px);
  text-align: left;
  padding-left: 0;
  cursor: pointer;
}
.rating-col:last-child {
  width: var(--size);
}
.rating-icon {
  align-items: start !important;
  justify-content: flex-start !important;
}
</style>
<style>
.rating-icon>svg {
  transition: all 0.5s ease 0s;
}
/* .rating-icon:hover>svg,
.rating-icon:focus>svg {
  fill: grey;
} */
</style>
